// Reports Template Box Container
// This component is a wrapper for any other Report Widget that goes inside to match the box style
// If a subChildren prop is passed, it will create a second box below the first one for additional context generally

import { Box } from '@mui/material';
import type { FC } from 'react';

import type BoxContainerProps from './ReportsTemplateBoxContiner.types';

const ReportsTemplateBoxContainer: FC<BoxContainerProps> = ({
  children,
  subChildren,
  height
}) => {
  return (
    <Box
      data-testid="reports-template-box-container"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minWidth: 100,
        flex: '1 1 120px',
        height: height || ''
      }}
    >
      {/* Top Gray Box */}
      <Box
        sx={{
          backgroundColor: '#eee',
          border: '1px solid #ccc',
          borderBottom: subChildren ? 'none' : '1px solid #ccc', // remove bottom border if subChildren exist
          paddingX: 2,
          paddingY: 1,
          height: height || 'auto'
        }}
      >
        {children}
      </Box>

      {/* Bottom White Box (optional) */}
      {subChildren && (
        <Box
          sx={{
            backgroundColor: '#fff',
            border: '1px solid #ccc',
            borderTop: 'none', // removes overlap border
            padding: 1,
            fontSize: 12,
            fontWeight: 400,
            height: height ? '100%' : 'auto'
          }}
        >
          {subChildren}
        </Box>
      )}
    </Box>
  );
};

export default ReportsTemplateBoxContainer;
